<template>
    <div class="main-container">
        <el-container class="main-el-container">
            <el-aside width="200px">
            <common-aside/>
            </el-aside>
            <el-container class="right-container">
                <el-header>
                    <common-header/>
                </el-header>
                <common-Tag/>
                <el-main class="content-main">
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import CommonAside from '../components/CommonAside.vue'
import CommonHeader from '../components/CommonHeader.vue'
import CommonTag from '../components/CommonTag.vue'
export default {
    components:{
        CommonAside,
        CommonHeader,
        CommonTag
    }
 
}
</script>

<style lang="less">
html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
}
</style>

<style lang="less" scoped>
.main-container {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
}

.main-el-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
}

.right-container {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
}

.el-header {
    padding: 0 !important;
    margin: 0;
    flex-shrink: 0;
}

.el-container {
    padding: 0;
    margin: 0;
}

.content-main {
    padding: 0 !important;
    margin: 0;
    overflow: hidden;
    flex: 1;
}

.el-footer,
el-header {
   padding: 0 !important;
}

.app {
   min-height: 100vh;
   display: flex;
   flex-direction: column;
}
</style>